
export const API_BASE_URL = 'https://www.luxlifemiamirealestate.com/api/api/'
export const IMG_URL = process.env.IMG_URL